import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { CardBody } from "reactstrap";
import { getMobileAppMySchedule } from "../../actions/axios-actions";
import Loader from "../../CommonElements/Loader";
import { H6 } from "../../AbstractElements";
import moment from "moment-timezone";

const selectedTimeZone = "America/Los_Angeles";

const MyStayColumns = [
  {
    name: <H6>Item</H6>,
    selector: (row) => {
      return row.name;
    },
    sortable: true,
    // center: true,
    minWidth: "300px",
    wrap: true,
  },

  {
    name: <H6>Name</H6>,
    selector: (row) => (row.customerName ? row.customerName : "-"),
    sortable: true,
    // center: true,
    minWidth: "200px",
    wrap: true,
  },
  {
    name: <H6>From</H6>,
    selector: (row) => row.from,
    sortable: true,
    center: true,
    minWidth: "172px",
  },
  {
    name: <H6 attrH6={{ className: "text-center" }}>Reservation ID</H6>,
    selector: (row) => (
      <div className="text-center w-100">{row.reservationId || "-"}</div>
    ),
    sortable: true,
    center: true,
    minWidth: "160px",
  },

  {
    name: <H6 attrH6={{ className: "text-center" }}>Room No.</H6>,
    selector: (row) => row.roomNo,
    sortable: true,
    center: true,
    minWidth: "100px",
  },
  {
    name: <H6 attrH6={{ className: "text-center" }}>Price/Item</H6>,
    selector: (row) =>
      (row.from == "Link booking")
        ? "-"
        : row.isPercentage
        ? (row.price || 0) + "%"
        : "$" + (row.price || 0),
    sortable: true,
    center: true,
    minWidth: "130px",
  },
  {
    name: <H6 attrH6={{ className: "text-center" }}>Date</H6>,
    selector: (row) =>
      moment(row.date?.split("T")[0]).tz("UTC", true).format("MMM DD, YYYY"),
    sortable: true,
    center: true,
    minWidth: "270px",
  },
  {
    name: <H6 attrH6={{ className: "text-center" }}>Time</H6>,
    selector: (row) => moment(row.time, "HH:mm").format("hh:mm A"),
    sortable: true,
    center: true,
    minWidth: "170px",
  },
  {
    name: <H6 attrH6={{ className: "text-center" }}>Status</H6>,
    selector: (row) => "-",
    sortable: true,
    center: true,
    minWidth: "170px",
  },
];
const MyStayTableData = (props) => {
  let {
    data,
    setData,
    loading,
    setTotalRows,
    perPage,
    setPerPage,
    searchText,
    myActiveTab,
    myStayFromSelectedObj,
    filterByActivity,
    myStayStartDate,
    myStayEndDate,
    myCurrentPage,
    setMyCurrentPage,
    myStayData,
  } = props;

  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const fetchData = ({
    newCurrentPage,
    newPerPage,
    startDate,
    endDate,
    stayFrom,
    activity,
  }) => {
    setData([]);

    const filters = {
      searchText: searchText,
      startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      stayFrom:
        myStayFromSelectedObj?.value !== "all"
          ? myStayFromSelectedObj?.value
          : null,
      activity:
        filterByActivity?.value !== "all" ? filterByActivity?.value : null,
      currentPage: newCurrentPage || myCurrentPage,
      perPage: newPerPage || perPage,
    };

    getMobileAppMySchedule(setData, setTableLoading, setTotalRows, filters);
  };

  // First Load: Always calls with startDate & endDate
  useEffect(() => {
    if (isFirstLoad) {
      fetchData({
        stayFrom:
          myStayFromSelectedObj?.value !== "all"
            ? myStayFromSelectedObj?.value
            : null,
        activity:
          filterByActivity?.value !== "all" ? filterByActivity?.value : null,
        startDate: myStayStartDate,
        endDate: myStayEndDate,
      });
      setIsFirstLoad(false);
    }
  }, []);

  useEffect(() => {
    if (!isFirstLoad) {
      fetchData({
        stayFrom:
          myStayFromSelectedObj?.value !== "all"
            ? myStayFromSelectedObj?.value
            : null,
        activity:
          filterByActivity?.value !== "all" ? filterByActivity?.value : null,
      });
    }
  }, [
    myStayFromSelectedObj?.value,
    filterByActivity?.value,
    myCurrentPage,
    perPage,
  ]);

  useEffect(() => {
    if (
      !isFirstLoad &&
      myActiveTab === "My-Stay" &&
      myStayStartDate &&
      myStayEndDate
    ) {
      fetchData({
        stayFrom:
          myStayFromSelectedObj?.value !== "all"
            ? myStayFromSelectedObj?.value
            : null,
        activity:
          filterByActivity?.value !== "all" ? filterByActivity?.value : null,
        startDate: myStayStartDate,
        endDate: myStayEndDate,
      });
    }
  }, [
    myStayStartDate,
    myStayEndDate,
    myActiveTab,
    myStayData,
    myCurrentPage,
    perPage,
  ]);

  // Handle Page Change
  const handlePageChange = (page) => {
    setMyCurrentPage(page);

    setData([]); // Optional: clear data before fetching new page
    fetchData({
      newCurrentPage: page,
      startDate: myStayStartDate,
      endDate: myStayEndDate,
    });
  };

  // Handle Rows Per Page Change
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    fetchData({
      newCurrentPage: myCurrentPage,
      newPerPage: newPerPage,
      startDate: myStayStartDate,
      endDate: myStayEndDate,
    });
  };

  useEffect(() => {
    setTableData(data);
  }, [data]);
  return (
    <Fragment>
      <CardBody>
        <div className="order-history table-responsive">
          <DataTable
            columns={MyStayColumns}
            data={tableData?.data || []}
            progressPending={tableLoading || loading}
            progressComponent={<Loader />}
            pagination
            paginationServer
            paginationTotalRows={tableData?.totalCount || 0}
            paginationDefaultPage={myCurrentPage}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            searching={true}
            paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
            pointerOnHover
          />
        </div>
      </CardBody>
      <style jsx global>{``}</style>
    </Fragment>
  );
};
export default MyStayTableData;